import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../login/login-dux";
import termsAndConditionSlice from "../login/termsAndCondition-dux";
import contactSlice from "../views/contactUs/contactUs-dux";

export default configureStore({
  reducer: {
    loginData: loginSlice,
    termsAndConditionData: termsAndConditionSlice,
    contactData: contactSlice
  },
});
